/**
 * Guest facing emails the CX team can re-trigger from the reservation edit view when the
 * original send never reached the guest. Values must match the admin-connect DTO.
 */
export enum GuestEmailType {
  CHECK_IN_CONFIRMATION = 'checkInConfirmation',
  PAYMENT_CONFIRMATION = 'paymentConfirmation'
}
